// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

let date = new Date()
let v = (date.getUTCFullYear() - 2019) + '.' + (date.getUTCMonth() + 1) + '.' + date.getUTCDate() + '.' + date.getUTCHours() + '.' + date.getUTCMinutes();
// First number correspond to the amount of years after 2019, which is the date that the
// program started the field testings
export const environment = {
  production: false,
  version: v,
  apiHost: 'http://localhost:3000',
  authHost: 'http://localhost:3005',
  viaCepHost: 'https://viacep.com.br',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts